import BaseService from '../commons/BaseService';
import { eEthereumTxType, } from '../commons/types';
import { ERC721Service } from '../erc721-contract';
import { ALMLeveragedPosition__factory } from './typechain/ALMLeveragedPosition__factory';
export class ALMLeveragedPosition extends BaseService {
    constructor(provider, leverageContractAddress, flashloanProviderAddress, assetConverterAddress) {
        super(provider, ALMLeveragedPosition__factory);
        this.leverageContractAddress = leverageContractAddress !== null && leverageContractAddress !== void 0 ? leverageContractAddress : '';
        this.flashloanProviderAddress = flashloanProviderAddress !== null && flashloanProviderAddress !== void 0 ? flashloanProviderAddress : '';
        this.assetConverterAddress = assetConverterAddress !== null && assetConverterAddress !== void 0 ? assetConverterAddress : '';
        this.erc721Service = new ERC721Service(provider);
    }
    deleverage({ user, position, maxSwapSlippage, withdrawLiquidity }) {
        const positionContract = ALMLeveragedPosition__factory.connect(position, this.provider);
        const txCallback = this.generateTxCallback({
            rawTxMethod: async () => positionContract.populateTransaction.deleverage(this.flashloanProviderAddress, { receiver: user, maxSwapSlippage: maxSwapSlippage, assetConverter: this.assetConverterAddress, withdrawLiquidity: withdrawLiquidity }),
            from: user,
        });
        return {
            tx: txCallback,
            txType: eEthereumTxType.DELEVERAGE,
            gas: this.generateTxPriceEstimation([], txCallback),
        };
    }
    deleverageTxData({ user, position, maxSwapSlippage, withdrawLiquidity }) {
        const tx = {};
        const txData = ALMLeveragedPosition__factory.createInterface().encodeFunctionData('deleverage', [this.flashloanProviderAddress, { receiver: user, maxSwapSlippage: maxSwapSlippage, assetConverter: this.assetConverterAddress, withdrawLiquidity: withdrawLiquidity }]);
        tx.data = txData;
        tx.to = position;
        tx.from = user;
        return tx;
    }
}
//# sourceMappingURL=index.js.map